<template>
  <div>
    <b-row>
      <!-- ฝั่งตลิ่งชัน -->
      <b-col
        lg="6"
        md="6"
        sm="12"
      >
        <b-card
          no-body
          class="d-flex justify-content-between align-items-right"
          style="height:auto;"
        >
          <b-card-body>
            <b-row class="text-center">
              <b-col
                lg="6"
                md="12"
                sm="12"
                class="mb-3"
              >
                <b-img
                  v-if="itemsVMS[2].isset === 1"
                  src="@/assets/images/icons/flooding/Floodinghighon.gif"
                  class="img-responsive"
                  alt="Flooding High On"
                />
                <b-img
                  v-else
                  src="@/assets/images/icons/flooding/Floodinghighoff.png"
                  class="img-responsive"
                  alt="Flooding High Off"
                />
              </b-col>
              <b-col
                lg="6"
                md="12"
                sm="12"
                class="mb-3"
              >
                <b-img
                  v-if="itemsVMS[3].isset === 1"
                  src="@/assets/images/icons/flooding/Floodinghighon.gif"
                  class="img-responsive"
                  alt="Flooding High On"
                />
                <b-img
                  v-else
                  src="@/assets/images/icons/flooding/Floodinghighoff.png"
                  fluid
                  class="img-responsive"
                  alt="Flooding High Off"
                />
              </b-col>
              <b-col
                lg="6"
                md="6"
                sm="12"
                class="mb-3"
              >
                <b-img
                  :src="status[0][itemsGroup[0].devstate]"
                  fluid
                  class="img-responsive mb-2"
                  alt="Device Status"
                />
                <div>{{ itemsGroup[0].devdesc }}</div>
              </b-col>
              <b-col
                lg="6"
                md="6"
                sm="12"
                class="mb-3"
              >
                <b-img
                  :src="status[0][itemsGroup[1].devstate]"
                  fluid
                  class="img-responsive mb-2"
                  alt="Device Status"
                />
                <div>{{ itemsGroup[1].devdesc }}</div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- ฝั่งบางกรวย -->
      <b-col
        lg="6"
        md="6"
        sm="12"
      >
        <b-card
          no-body
          class="d-flex justify-content-between align-items-right"
        >
          <b-card-body>
            <b-row class="text-center">
              <b-col
                lg="12"
                md="12"
                sm="12"
                class="mb-3"
              >
                <b-img
                  v-if="itemsVMS[4].isset === 1"
                  src="@/assets/images/icons/flooding/Floodinghighon.gif"
                  class="img-responsive"
                  alt="Flooding High On"
                />
                <b-img
                  v-else
                  src="@/assets/images/icons/flooding/Floodinghighoff.png"
                  class="img-responsive"
                  alt="Flooding High Off"
                />
              </b-col>
              <b-col
                lg="6"
                md="6"
                sm="12"
                class="mb-3"
              >
                <b-img
                  :src="status[0][itemsGroup[2].devstate]"
                  fluid
                  class="img-responsive mb-2"
                  alt="Device Status"
                />
                <div>{{ itemsGroup[2].devdesc }}</div>
              </b-col>
              <b-col
                lg="6"
                md="6"
                sm="12"
                class="mb-3"
              >
                <b-img
                  :src="status[0][itemsGroup[3].devstate]"
                  fluid
                  class="img-responsive mb-2"
                  alt="Device Status"
                />
                <div>{{ itemsGroup[3].devdesc }}</div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BCard, BCardBody,
  BImg,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { Icon, CRS } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import axios from '@axios'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BImg,
    BCardBody,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      revenueGenerated: {},
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png',
      attribution: '',
      zoom: 7,
      center: [18.839867, 98.973773],
      bounds: [[-500, -1000], [550, 1500]],
      // bounds1: [[-500, -1050], [550, 1850]],
      markers: [],
      markersFlooding: [],
      minZoom: -100,
      crs: CRS.Simple,
      // -----ข้อมูลในมุด--------
      fieldsPin: [
        {
          key: 'devdesc', label: 'ชื่อ:',
        },
        {
          key: 'status', label: 'สถานะ:',
        },
      ],
      // --------history--------
      perPage: 10,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      // --------ผลรวม--------
      Total: '',
      Online: '',
      Offline: '',
      items: [],
      status: [
        {
          0: require('@/assets/images/icons/flooding/water-level-new1.png'),
          1: require('@/assets/images/icons/flooding/water-level-new2.gif'),
          2: require('@/assets/images/icons/flooding/water-level-new3.gif'),
          3: require('@/assets/images/icons/flooding/water-level-new4.gif'),
          4: require('@/assets/images/icons/flooding/water-level-new5.gif'),
          5: require('@/assets/images/icons/flooding/water-level-new6.gif'),
          6: require('@/assets/images/icons/flooding/water-level-new7.gif'),
        }],
      date: {
        DateFrom: '',
        DateTo: '',
      },
      rtsp: [],
      name: [],
      rtspData: [],
      ISOnline: [],
      rtsp1: [],
      name1: [],
      rtspData1: [],
      ISOnline1: [],
      itemsVMS: [],
      itemsGroup: [],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      // If the user IS an admin, return all fields.
      return this.fields
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
    clearInterval(this.interval1)
  },
  mounted() {
    // this.getCheckAlert()
    this.getFlooding()
    this.Sensor()
    this.getSumFlooding()
    this.getevenFlooding()
    this.getFloodingVMS()
    this.getFloodingGroup()
    // this.interval = setInterval(() => {
    //   this.for()
    // }, 300000)
    this.interval1 = setInterval(() => {
      // this.getCheckAlert()
      this.getFlooding()
      this.Sensor()
      this.getSumFlooding()
      this.getevenFlooding()
      this.getFloodingVMS()
      this.getFloodingGroup()
    }, 10000)
    // this.$refs.map1.mapObject.setView([0, 150], -2)
  },
  methods: {
    getFloodingVMS() {
      axios
        .post('/vmsFlooding', { wid: this.$route.query.wid })
        .then(response => {
          this.itemsVMS = response.data
        })
    },
    getFlooding() {
      axios
        .post('/getFloodingSensor', { wid: this.$route.query.wid })
        .then(response => {
          this.itemsensor = response.data
          this.totalRows = response.data.length
        })
    },
    getFloodingGroup() {
      axios
        .post('/imgFlooding', { wid: this.$route.query.wid })
        .then(response => {
          this.itemsGroup = response.data
        })
    },
    getInfoFlooding(devid, devdesc, devtype, status, lastupdate) {
      this.items = []
      this.items.push({
        devid,
        devdesc,
        devtype,
        status,
        lastupdate,
      })
    },
    getSumFlooding() {
      axios
        .post('/get_totalFlooding')
        .then(response => {
          this.Total = response.data[0].Total
          this.Online = response.data[0].Online
          this.Offline = response.data[0].Offline
        })
        .catch(error => {
          console.log(error)
        })
    },
    getevenFlooding() {
      axios
        .post('/get_eventFlooding')
        .then(response => {
          this.itemseven = response.data
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    Sensor() {
      axios
        .post('/fetch_sensor', this.date)
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
    },
    getCheckAlert() {
      axios
        .post('/alertFloodingCMI')
        .then(response => {
          if (response.data.lenght !== 0) {
            this.devstate = response.data[0].devstate
            this.devdesc = response.data[0].devdesc
            this.devid = response.data[0].devid
            this.lastupdate = response.data[0].tdate
            if (response.data[0].devstate === '0') {
              this.FilePath = require('@/assets/images/icons/flooding/water-level-0_0.png')
            } else if (response.data[0].devstate === '5') {
              this.FilePath = require('@/assets/images/icons/flooding/water-level-5_0.png')
            } else if (response.data[0].devstate >= '10') {
              this.FilePath = require('@/assets/images/icons/flooding/water-level-10_0.png')
            }
            this.playSound()
            this.Alert()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    playSound() {
      // eslint-disable-next-line global-require
      this.audio = new Audio(require('@/assets/media/alarm.mp3'))
      this.audio.play()
    },
    Alert() {
      this.$swal({
        position: 'top-start',
        title: `<span style="color:#000000;"> มีน้ำท่วมขัง </span>
        <span style="color:#000000;font-size: 20px"> (เซ็นเซอร์น้ำท่วมตัวที่ ${this.devdesc.slice(6, 7)}) </span>
            <span style="color:#000000; font-size: 20px; font-weight: normal">ระดับน้ำ ${this.devstate} ซม.</span>`,
        imageUrl: this.FilePath,
        imageWidth: 300,
        imageHeight: 200,
        imageAlt: 'Custom image',
        footer: `<span style="color:#000000;"> แจ้งเตือนวันที่ ${this.lastupdate} </span>`,
      }).then(async result => {
        if (result.value) {
          try {
            await axios.post('/closeFloodingCMI', { ack: 1, devid: this.devid })
            this.$swal({
              icon: 'success',
              title: '<span style="color:#000000">ปิดแจ้งเตือนเรียบร้อยแล้ว</span>',
              showConfirmButton: false,
              timer: 1000,
            })
          } catch (error) {
            this.$swal({
              title: 'Error!',
              text: ' Click to continue!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.img-responsive {
  max-height: 200px;
  width: auto;
  max-width: 100%;
  height: 280px;
}
</style>
